<template>
  <div class="page-pay-ahead">
    <el-form :inline="true" :model="searchForm" ref="searchForm" :show-message="false">
      <el-form-item prop="bizLine" label="业务线" required>
        <el-select :clearable="false" v-model="searchForm.bizLine">
          <el-option
            v-for="item in commonOptionList.businessTypeList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="cityCode" label="城市" required>
        <el-select filterable v-model="searchForm.cityCode" @change="getSupplierList">
          <el-option
            v-for="item in citiesInfo"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="supplierId" label="供应商名称" required>
        <el-select filterable v-model="searchForm.supplierId" :disabled="!searchForm.cityCode">
          <el-option
            v-for="item in supplierList"
            :label="item.supplierName"
            :value="item.supplierId"
            :key="item.supplierId"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="period" label="结算账期">
        <el-date-picker
          v-model="searchForm.period"
          type="month"
          value-format="yyyy-MM"
          :pickerOptions="pickerOptions"
          :disabled="disableDate"
        />
      </el-form-item>
      <el-form-item prop="subtype" label="工作类型">
        <el-select clearable v-model="searchForm.subtype">
          <el-option
            v-for="item in subtypeList"
            :label="item.name"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="orderPayWay" label="结算单类型">
        <el-select clearable v-model="searchForm.orderPayWay">
          <el-option label="非提前付款且非个人付款" :value="0" />
          <el-option label="提前付款" :value="1" />
          <el-option label="个人付款" :value="8" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          @click="fetchList(true)"
          :loading="isLoading"
          type="primary"
          :disabled="!this.searchForm.cityCode || !this.searchForm.supplierId"
          >搜索</el-button
        >
        <el-button @click="resetSearchForm">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="ui-card ui-card-body">
      <div class="pay-ahead-btns">
        <el-button
          @click="payAhead(8, 93)"
          :disabled="!this.selectedItem.length"
          :loading="isPaying"
          >个人报销已付款</el-button
        >
        <el-button @click="payAhead(1)" :disabled="!this.selectedItem.length" :loading="isPaying"
          >提前付款</el-button
        >
      </div>
      <el-table
        v-loading="isLoading"
        :data="dataList"
        @selection-change="onSelectionChange"
        ref="multipleTable"
      >
        <el-table-column
          fixed
          type="selection"
          width="55"
          :selectable="row => row.orderPayWay === 0"
        />
        <el-table-column label="供应商名称" prop="supplier" width="220" />
        <el-table-column label="费用结算日期" prop="day" width="100" />
        <el-table-column label="业务发生日期" prop="actualDay" width="100" />
        <el-table-column label="是否跨账期" prop="hasTransName" />
        <el-table-column label="价格ID" prop="priceIdName" width="140" />
        <el-table-column label="城市" prop="city" width="150" />
        <el-table-column label="Region Name" prop="regionName" width="150" />
        <el-table-column label="计量单位" prop="unitName" />
        <el-table-column label="结费对象" prop="costObjectName" />
        <el-table-column label="工作类型" prop="subtypeName" width="120" />
        <el-table-column label="运载工具" prop="vehicleName" />
        <el-table-column label="结算额(元)" prop="amount" />
        <el-table-column label="发票类型" prop="invoiceTypeName" width="120" />
        <el-table-column label="税率(%)" prop="tax" />
        <el-table-column label="结算单类型" prop="orderPayWayName" width="100" />
      </el-table>
      <div class="paging-wrapper" v-if="totalPages > 1">
        <el-pagination
          @current-change="handlePageNoChange"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          layout="prev, pager, next, slot, jumper"
          :total="totalAmount"
        >
          <span class="page-indicator"
            ><em>{{ pageNo }}</em
            >/{{ totalPages }}</span
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/utils'

import {
  computedCitiesInfo,
  commonOpt as commonOptionList,
  pagination,
  filtersFormatDate,
} from '@/mixins'

export default {
  mixins: [computedCitiesInfo, commonOptionList, pagination, filtersFormatDate],
  computed: {
    disableDate() {
      const date = new Date()
      if (date.getDate() === 25) {
        return false
      } else {
        return true
      }
    },
    pickerOptions() {
      const date = new Date()
      if (date.getDate() === 25) {
        // 25号当天，允许选择 上个账期 和 当前账期
        const validAccountPeriods = this.getValidAccountPeriods()
        return {
          disabledDate(date) {
            const thisMonth = date.getMonth() + 1
            const thisYear = date.getFullYear()
            const accountPeriod = thisYear + '-' + thisMonth.toString().padStart(2, '0')
            return !validAccountPeriods.includes(accountPeriod)
          },
        }
      } else {
        // 25号以外禁止选择
        return null
      }
    },
  },

  data() {
    return {
      isLoading: false,
      isPaying: false,
      supplierList: [],
      subtypeList: [],
      dataList: [],
      selectedItem: [],
      searchForm: {
        supplierId: '',
        period: '',
        bizLine: 1204,
        cityCode: '',
        subtype: '',
        orderPayWay: '',
      },
    }
  },

  created() {
    this.searchForm.cityCode = this.$store.state.currentCity
    // 计算账期
    const date = new Date()
    if (date.getDate() > 24) {
      date.setDate(1) // 设为1号，否则当前为31号时会导致setMonth+1多一个月
      date.setMonth(date.getMonth() + 1)
    }
    this.searchForm.period = dateFormat(date, 'yyyy-MM')
    this.getSupplierList()
    this.getSubtypeList()
    this.initPagination('fetchList', false)
  },

  methods: {
    resetSearchForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm.supplierId = this.supplierList[0] && this.supplierList[0].supplierId
    },

    // 选择列表
    onSelectionChange(val) {
      this.selectedItem = val
    },

    // 计算账期
    getValidAccountPeriods() {
      const date = new Date()
      // 上个账期（物理时间是当月）
      const period1 = dateFormat(date, 'yyyy-MM')

      // 当前账期(物理时间是下个月)
      date.setMonth(date.getMonth() + 1)
      const period2 = dateFormat(date, 'yyyy-MM')

      return [period1, period2]
    },

    // 列表
    fetchList(init = false) {
      if (this.searchForm.bizLine === 1203) {
        return this.$message.error('无电单车业务线权限')
      }
      if (init) this.pageNo = 1
      const params = {
        ...this.searchForm,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      this.isLoading = true
      this.fetch
        .post('srm_payAheadList', params)
        .then(res => {
          this.isLoading = false
          const { lists = [], count = 0 } = res.data || {}
          this.dataList = lists
          this.totalAmount = count
        })
        .catch(res => {
          this.isLoading = false
        })
    },

    // 提前付款
    payAhead(orderPayWay, workSubType) {
      const params = {
        supplierId: this.searchForm.supplierId,
        period: this.searchForm.period,
        cityCode: this.searchForm.cityCode,
        bizLine: this.searchForm.bizLine,
        adjustIdList: [],
        orderPayWay,
      }
      let invalidTip = ''
      this.selectedItem.forEach(item => {
        params.adjustIdList.push(item.id)
        // 个人付款工作类型限定为“维护费用-罚款”，如果选择其他类型，则报错“勾选的业务类型不支持个人报销已付款流程”
        if (!invalidTip && workSubType && item.subtype !== workSubType) {
          invalidTip = '勾选的业务类型不支持个人报销已付款流程'
        }
      })
      if (invalidTip) return this.$message.error(invalidTip)
      this.isPaying = true
      this.fetch
        .post('srm_payAheadOrderCreate', params)
        .then(res => {
          this.$msgbox
            .alert(`操作成功，对账单编号为：${res.data || ''}`, '', {
              type: 'success',
              showClose: false,
            })
            .then(() => {
              this.isPaying = false
              this.fetchList()
              this.selectedItem = []
            })
            .catch(() => {
              //
            })
        })
        .catch(res => {
          this.isPaying = false
        })
    },

    // 获取工作类型
    getSubtypeList() {
      this.fetch
        .get('srm_payAheadSubtypeList')
        .then(res => {
          this.subtypeList = res.data || []
        })
        .catch(() => {})
    },

    // 获取供应商列表
    getSupplierList() {
      const params = {
        cityCode: this.searchForm.cityCode,
      }
      if (!params.cityCode) return
      this.fetch
        .get('srm_settlementQuerySuppliers', { params })
        .then(res => {
          this.supplierList = res.data || []
          this.searchForm.supplierId = this.supplierList[0] && this.supplierList[0].supplierId
        })
        .catch(res => {
          this.supplierList = []
          this.searchForm.supplierId = ''
        })
    },
  },
}
</script>

<style scoped lang="scss">
.pay-ahead-btns {
  text-align: right;
  margin: 10px 0;
  .el-button:not(:last-child) {
    margin-right: 10px;
  }
}
.module-title {
  margin-bottom: 10px;
}
</style>
